export class QrScanResult {
    constructor(arg) {
        Object.assign(this, arg);
    }
}
export class SiteInformation {
    constructor(arg) {
        Object.assign(this, arg);
    }
}
export class JobInformation {
    constructor(arg) {
        Object.assign(this, arg);
    }
}
export class TimesheetInformation {
    constructor(arg) {
        Object.assign(this, arg);
    }
}
export class TimesheetDay {
    constructor(arg) {
        Object.assign(this, arg);
    }
}
export class TaskInformation {
    constructor(arg) {
        Object.assign(this, arg);
    }
}
export var QrCodeType;
(function (QrCodeType) {
    QrCodeType[QrCodeType["Timesheet"] = 0] = "Timesheet";
    QrCodeType[QrCodeType["Task"] = 1] = "Task";
})(QrCodeType || (QrCodeType = {}));
export var QrScanAction;
(function (QrScanAction) {
    QrScanAction[QrScanAction["TimesheetCheckIn"] = 0] = "TimesheetCheckIn";
    QrScanAction[QrScanAction["TimesheetCheckOut"] = 1] = "TimesheetCheckOut";
    QrScanAction[QrScanAction["TaskComplete"] = 2] = "TaskComplete";
})(QrScanAction || (QrScanAction = {}));
